import React from "react";
import "./Support.scss";

function Support() {
  return (
    <div className="support-page">
      <div className="support-container">
        <h1>Banke Support Center</h1>
        <p>
          Welcome to Banke Support. We're here to help you with orders,
          payments, deliveries, returns, refunds, vendor inquiries, and
          account-related issues.
        </p>

        <div className="support-card">
          <h2>Contact Support</h2>
          <p>
            <strong>Email:</strong> support@banke.com.ng
          </p>
          <p>
            Our support team aims to respond within <strong>24–48 hours</strong>
            .
          </p>
        </div>

        <h2>Frequently Requested Help</h2>

        <div className="support-card">
          <h3>Orders</h3>
          <ul>
            <li>Track an order</li>
            <li>Report a missing or damaged item</li>
            <li>Cancel an order (where eligible)</li>
            <li>Order status updates</li>
          </ul>
        </div>

        <div className="support-card">
          <h3>Payments</h3>
          <ul>
            <li>Payment verification</li>
            <li>Failed transactions</li>
            <li>Refund requests</li>
            <li>Transaction reference assistance</li>
          </ul>
        </div>

        <div className="support-card">
          <h3>Account</h3>
          <ul>
            <li>Reset password</li>
            <li>Update personal information</li>
            <li>Google Sign-In issues</li>
            <li>Account security concerns</li>
          </ul>
        </div>

        <div className="support-card">
          <h3>Vendors</h3>
          <ul>
            <li>Vendor registration</li>
            <li>Product listing assistance</li>
            <li>Settlement and payout inquiries</li>
            <li>Marketplace support</li>
          </ul>
        </div>

        <h2>Returns and Refunds</h2>
        <p>
          If you need to return an item, you can initiate a return from your
          order history in the Banke app or contact our support team with your
          order number.
        </p>

        <h2>Business Hours</h2>
        <ul>
          <li>
            Monday – Friday: <strong>9:00 AM – 6:00 PM (WAT)</strong>
          </li>
          <li>
            Saturday: <strong>10:00 AM – 4:00 PM (WAT)</strong>
          </li>
          <li>
            Sunday: <strong>Closed</strong>
          </li>
        </ul>

        <h2>Company Information</h2>
        <p>
          <strong>Banke Store</strong>
          <br />
          Lagos, Nigeria
          <br />
          Website: https://banke.com.ng
          <br />
          Email: support@banke.com.ng
        </p>
      </div>
    </div>
  );
}

export default Support;
